import { ChatRole } from '@quicktools/shared-components/services/chatApi/types';

import analytics from '../../services/analytics';
import chatApi from '../../services/chatApi';
import { GPT_VERSION } from '../../constants';
import { State } from '../../components/HomePages/GenerateExample/types';

import { getUserSessionId } from './localStorage';

const messages = [
  {
    role: 'system' as ChatRole,
    content:
      'You are a compliment generator. Whenever someone asks you for a compliment, you give a nice and fun compliment with a friendly tone. Be creative and use emojis! Use max. 65 characters.',
  },
  { role: 'user' as ChatRole, content: 'Give me a compliment' },
];

export default async function getCompliment({ setState, setResult }) {
  setState(State.Loading);

  analytics.pageClick({
    page_path: window.location.pathname,
    action_type: 'generate_example',
    category_name: 'ai_writer',
  });

  try {
    const { payload } = await chatApi.getResponse({
      model: GPT_VERSION,
      messages,
      user: getUserSessionId(),
    });
    setResult(payload.choices[0].message.content);
    setState(State.Loaded);
  } catch (e) {
    console.error(e);
    setResult('Request failed, try again in a moment.');
    setState(State.Loaded);
    setTimeout(() => {
      setState(State.Initial);
    }, 4000);
  }
}
